/*
 * Page dédiée au listing des équipement (avec filtres)
 */
import {
    Container,
    Center,
    Spinner,
    Box,
    Wrap,
    TableContainer,
    Table,
    Thead,
    Th,
    Tooltip,
    Td,
    Text,
    Tr,
    Tbody,
} from '@chakra-ui/react'
import { Agence, Entreprise, Equipement } from '../../model'
import { Link as ReactRouterLink } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'
import { AuthContext } from '../../auth/AuthContextProvider'
import { GetAllVelos } from '../../firebaseManager/Communicator/EquipementCommunicator'
import { BreadCrumbBuilder } from '../../components/BreadCrumbBuilder'
import { ConditionalConnectAdminComplex } from '../../auth/ConditionalConnectAdminComplex'
import { CustomBox } from '../../components/CustomBox'
import { GetAllEntreprises } from '../../firebaseManager/Communicator/EntrepriseCommunicator'
import { GetAllAgences } from '../../firebaseManager/Communicator/AgenceCommunicator'
import moment from 'moment'

export type FilterEquipementValue = {
    categorie: string
    marque: string
    modele: string
    numeroSerie: string
    numeroMarquage: string
    entrepriseAppartenance: string
    agenceAppartenance: string
    hivernage: boolean
    partager: boolean
}

export const ManageVelos = () => {
    const [allEquipements, setAllEquipements] = useState<Equipement[] | null>()
    const [allEntreprises, setAllEntreprises] = useState<Entreprise[] | null>()
    const [allAgences, setAllAgences] = useState<Agence[] | null>()

    const authentification = useContext(AuthContext)

    function refreshAllEquipements() {
        GetAllVelos()
            .then((result: Equipement[]) => {
                const sortedResult = result.sort((a, b) => {
                    if (
                        !a.dateDerniereMaintenance &&
                        !b.dateDerniereMaintenance
                    ) {
                        return 0
                    }
                    if (!a.dateDerniereMaintenance) {
                        return 1
                    }
                    if (!b.dateDerniereMaintenance) {
                        return -1
                    }
                    return a.dateDerniereMaintenance - b.dateDerniereMaintenance
                })
                console.log(sortedResult)
                setAllEquipements(sortedResult)
            })
            .catch((e) => setAllEquipements(null))
    }

    function RefreshAllEntreprises() {
        GetAllEntreprises()
            .then((result) => {
                setAllEntreprises(result)
            })
            .catch((e) => setAllEntreprises(null))
    }

    function RefreshAllAgences() {
        GetAllAgences()
            .then((result) => {
                setAllAgences(result)
            })
            .catch((e) => setAllAgences(null))
    }

    useEffect(() => {
        if (authentification.firebaseUser != null) {
            refreshAllEquipements()
            RefreshAllEntreprises()
            RefreshAllAgences()
        }
    }, [authentification])

    function GetAgenceName(agenceId: string) {
        return allAgences?.find((agence) => agence.id === agenceId)?.nom
    }

    function GetEntrepriseName(entrepriseId: string) {
        return allEntreprises?.find(
            (entreprise) => entreprise.id === entrepriseId
        )?.nom
    }

    return (
        <ConditionalConnectAdminComplex>
            <BreadCrumbBuilder
                items={[
                    {
                        name: 'Tous les vélos',
                        url: '',
                    },
                ]}
            />

            <Container maxW="100%">
                {allEquipements == null && (
                    <CustomBox p={'40px'} ml={'50px'} mr={'50px'}>
                        <Center>
                            <Spinner
                                thickness="4px"
                                speed="0.65s"
                                emptyColor="gray.200"
                                color="blue.500"
                                size="xl"
                            />
                        </Center>
                        <Center>Chargement des équipements</Center>
                    </CustomBox>
                )}
                {allEquipements && allEquipements?.length === 0 && (
                    <CustomBox p={'40px'} ml={'50px'} mr={'50px'}>
                        <Center>Il n'existe pas encore d'équipements</Center>
                    </CustomBox>
                )}
                {allEquipements && allEquipements?.length > 0 && (
                    <Wrap>
                        <TableContainer w={'100%'}>
                            <Table variant="striped">
                                <Thead>
                                    <Tr>
                                        <Th textAlign="center">modele</Th>
                                        <Th textAlign="center">entreprise</Th>
                                        <Th textAlign="center">agence</Th>
                                        <Th textAlign="center">utilisateur</Th>
                                        <Th textAlign="center">kilometrage</Th>
                                        <Th textAlign="center">maintenance</Th>
                                        <Th textAlign="center">voir</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {allEquipements?.map(function (
                                        equipement,
                                        idx
                                    ) {
                                        const kilometrageDepuisMaintenance =
                                            (equipement.kilometrage ?? 0) -
                                            (equipement.kilometrageDerniereMaintenance ??
                                                0)
                                        const JoursDepuisMaintenance =
                                            moment().diff(
                                                moment(
                                                    equipement.dateDerniereMaintenance
                                                ),
                                                'days'
                                            )

                                        const nomModele =
                                            equipement.modele ?? 'NC'
                                        const nomModeleCourt =
                                            nomModele.substring(0, 12) +
                                            (nomModele.length > 12 ? '...' : '')
                                        const nomEntreprise =
                                            GetEntrepriseName(
                                                equipement.entrepriseAppartenance ??
                                                    ''
                                            ) ?? 'NC'
                                        const nomEntrepriseCourt =
                                            nomEntreprise.substring(0, 12) +
                                            (nomEntreprise.length > 12
                                                ? '...'
                                                : '')
                                        const nomAgence =
                                            GetAgenceName(
                                                equipement.agenceAppartenance ??
                                                    ''
                                            ) ?? 'NC'
                                        const nomAgenceCourt =
                                            nomAgence.substring(0, 12) +
                                            (nomAgence.length > 12 ? '...' : '')
                                        return (
                                            <>
                                                <Tr key={idx}>
                                                    <Td>
                                                        <Tooltip
                                                            label={nomModele}
                                                        >
                                                            {nomModeleCourt}
                                                        </Tooltip>
                                                    </Td>
                                                    <Td>
                                                        <Tooltip
                                                            label={
                                                                nomEntreprise
                                                            }
                                                        >
                                                            <Box
                                                                as={
                                                                    ReactRouterLink
                                                                }
                                                                to={
                                                                    '/edit_enterprise?id_entreprise=' +
                                                                    equipement.entrepriseAppartenance
                                                                }
                                                                textAlign="center"
                                                            >
                                                                <Text fontSize="xl">
                                                                    🏢
                                                                </Text>
                                                                <Text
                                                                    fontSize="sm"
                                                                    pt="5px"
                                                                >
                                                                    {
                                                                        nomEntrepriseCourt
                                                                    }
                                                                </Text>
                                                            </Box>
                                                        </Tooltip>
                                                    </Td>
                                                    <Td>
                                                        <Tooltip
                                                            label={nomAgence}
                                                        >
                                                            <Box
                                                                as={
                                                                    ReactRouterLink
                                                                }
                                                                to={
                                                                    '/edit_agence?id_entreprise=' +
                                                                    equipement.entrepriseAppartenance +
                                                                    '&id_agence=' +
                                                                    equipement.agenceAppartenance
                                                                }
                                                                textAlign="center"
                                                            >
                                                                <Text fontSize="xl">
                                                                    🏢
                                                                </Text>
                                                                <Text
                                                                    fontSize="sm"
                                                                    pt="5px"
                                                                >
                                                                    {
                                                                        nomAgenceCourt
                                                                    }
                                                                </Text>
                                                            </Box>
                                                        </Tooltip>
                                                    </Td>
                                                    <Td>
                                                        <Box
                                                            as={ReactRouterLink}
                                                            to={
                                                                '/edit_utilisateur?id_utilisateur=' +
                                                                equipement.utilisateurAppartenance
                                                            }
                                                            textAlign="center"
                                                        >
                                                            <Text fontSize="3xl">
                                                                👤
                                                            </Text>
                                                        </Box>
                                                    </Td>
                                                    <Td>
                                                        <Text
                                                            color={
                                                                kilometrageDepuisMaintenance >
                                                                1300
                                                                    ? 'red'
                                                                    : kilometrageDepuisMaintenance >
                                                                      800
                                                                    ? 'orange'
                                                                    : 'green'
                                                            }
                                                        >
                                                            {
                                                                kilometrageDepuisMaintenance
                                                            }
                                                            km
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Text
                                                            color={
                                                                JoursDepuisMaintenance >
                                                                365
                                                                    ? 'red'
                                                                    : JoursDepuisMaintenance >
                                                                      180
                                                                    ? 'orange'
                                                                    : 'green'
                                                            }
                                                        >
                                                            {
                                                                JoursDepuisMaintenance
                                                            }{' '}
                                                            jours
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Box
                                                            as={ReactRouterLink}
                                                            to={
                                                                '/edit_equipement?id_equipement=' +
                                                                equipement.id
                                                            }
                                                            textAlign="center"
                                                        >
                                                            <Text fontSize="3xl">
                                                                🚲
                                                            </Text>
                                                        </Box>
                                                    </Td>
                                                </Tr>
                                            </>
                                        )
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Wrap>
                )}
            </Container>
        </ConditionalConnectAdminComplex>
    )
}
